import React, {useContext} from 'react';
import objectDataHolder from "../../Hooks/ObjectDataHolder";
import {BalanceSheetContext} from "./BalanceSheetContext";
import FilterSection from "./FilterSection";
import TableShow from "./TableShow";
import "./style.scss"
import "./balacesheet2.scss"
import {SetPrintDataContext} from "../../../Pages";
import {useNavigate} from "react-router-dom";


function BalanceSheet2() {

  const setprint = useContext(SetPrintDataContext);
  let navigate = useNavigate();
  const [data, setData] = objectDataHolder({
    dateFilter: {
      "type": "all",
      "startDate": "",
      "endDate": "",
      year: "",
      month: "",
    },

    documentNumberFilter: {firstId: "", lastId: ""},
    reportType: "0", // kol0 grouh1 moein2
    mainData: {
      column: [],
      data: [],
      priceFields:[],
    },
  })

  const GoPrintPage = () => {
    const sendData = {
      type: "BalanceSheetPrint",
      data: data,
    };
    setprint(sendData);
    navigate("/factorprint");
  }

  return (<BalanceSheetContext.Provider value={{data, setData}}>
    <div className={"balance__sheet2 bg__white"}>
      <FilterSection/>
      <TableShow/>

      <div className="">
        <button

          className={"btn btn__secondary_purple wh104x28font14 p-0 m-2 my-5"}
          onClick={GoPrintPage}>چاپ</button>
      </div>
    </div>
  </BalanceSheetContext.Provider>);
}

export default BalanceSheet2;